export default __webpack_public_path__ + "static/media/icon_chef.5f6b0281.svg";